import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'mwo-update-refresh-dialog',
  templateUrl: './update-refresh-dialog.component.html',
  styleUrls: ['./update-refresh-dialog.component.scss']
})
export class UpdateRefreshDialogComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit(): void {
  }


  updateApp() {
    this.data.updates.activateUpdate().then(() => document.location.reload());
    this.data.dialogRef?.close();
  }
}
